import React from 'react';
import { KPI_DATA, LM_TOKENS } from '../../live-monitor/config';
import { Icon } from '../Icon/Icon';

export function LiveMonitorKpiStrip() {
  return (
    <div
      className="lm-fade-up lm-d-1 mb-7 grid gap-3"
      style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}
    >
      {KPI_DATA.map((k) => {
        const deltaColor =
          k.deltaColor === 'positive'
            ? LM_TOKENS.greenDeep
            : k.deltaColor === 'warning'
              ? LM_TOKENS.warning
              : LM_TOKENS.ink3;

        return (
          <div
            key={k.key}
            className="lm-kpi-card flex flex-col gap-1.5 rounded-[14px] border border-[var(--cream-2)] bg-[var(--cream-1)] p-4 pb-4 shadow-[var(--sh-1)]"
            style={{ padding: '14px 16px 16px' }}
          >
            <div className="flex items-center gap-[7px]">
              <div className="inline-flex h-6 w-6 items-center justify-center rounded-[7px] bg-[var(--surface-mute)] text-[var(--ink-2)]">
                <Icon kind={k.icon} size={12} stroke={2} />
              </div>
              <div className="lm-eyebrow text-[10px]">{k.label}</div>
            </div>
            <div className="lm-tab-num mt-1 text-[38px] font-semibold leading-none tracking-[-0.03em] text-[var(--ink-0)]">
              {k.value}
            </div>
            <div
              className="mt-1 text-[12px] font-medium tracking-[-0.005em]"
              style={{ color: deltaColor }}
            >
              {k.delta}
            </div>
          </div>
        );
      })}
    </div>
  );
}
